import React from 'react';

import styled from 'styled-components';
import { GutterCSS, StyledTooltip } from 'styles/common';

import { InfoIcon2 } from 'constants/icons';
import theme from 'constants/theme';

const MarginWrapper = styled.div`
  ${GutterCSS};
  display: inline-flex;
`;

const NonStyledAnchor = styled.a`
  font-size: 0;
`;

export default function TooltipInfo({ title = '', linkUrl = '', ...props }) {
  const { leftGutter, rightGutter, topGutter, bottomGutter } = props;
  const gutterProps = { leftGutter, rightGutter, topGutter, bottomGutter };
  return (
    <MarginWrapper {...gutterProps}>
      <StyledTooltip title={title}>
        {linkUrl ? (
          <NonStyledAnchor target={`_${linkUrl}`} href={linkUrl}>
            <InfoIcon2 color={theme.palette.icons.grey4} size="fixed16px" />
          </NonStyledAnchor>
        ) : (
          <InfoIcon2 color={theme.palette.icons.grey4} size="fixed16px" />
        )}
      </StyledTooltip>
    </MarginWrapper>
  );
}
